module.exports = __webpack_public_path__ + "img/DSC_0063.3cb16260.jpg";